/* mm-plusminus.js — aus Sonne und Mond werden Plus und Minus.
 *
 * 29.08.2026, Mert: „nicht sonne und mond sondern + für zunehmen, - für abnehmen"
 *
 * WO DAS SITZT
 *   In der Section-Store-Sektion `ss_feature_32` auf der Startseite. Sie zeigt
 *   „ZUNEHMEN" mit der Zunehmen-Kollektion und schaltet über einen Kippschalter
 *   auf die Abnehmen-Seite um. Der Schalter kam ab Werk mit einem Tag/Nacht-Bild:
 *   links eine Sonne, rechts ein Mond. Inhaltlich sagt das nichts - Plus und
 *   Minus dagegen sagen genau, worum es geht.
 *
 * WARUM DIE SVG-KNOTEN BLEIBEN
 *   Die Sektion gehört einer App; ihre eigene Logik greift auf diese Knoten zu.
 *   Deshalb werden sie NICHT ersetzt, sondern nur ihr Inhalt ausgetauscht -
 *   aus den Pfaden wird ein `<text>`. Der Schalter selbst, seine Klassen und
 *   sein Verhalten bleiben unangetastet.
 *
 * `currentColor` sorgt dafür, dass Plus und Minus dieselbe Farbe annehmen wie
 * vorher die Symbole - auch wenn die Sektion beim Umschalten die Farbe wechselt.
 */
(function () {
  'use strict';

  function zeichen(svg, glyph, titel) {
    if (svg.dataset.mmPM) return;
    svg.dataset.mmPM = '1';
    svg.setAttribute('viewBox', '0 0 56 56');
    svg.innerHTML =
      '<title>' + titel + '</title>' +
      '<text x="28" y="29" text-anchor="middle" dominant-baseline="middle" ' +
      'font-family="Manrope, system-ui, sans-serif" font-size="40" font-weight="800" ' +
      'fill="currentColor" stroke="none">' + glyph + '</text>';
    svg.setAttribute('role', 'img');
    svg.setAttribute('aria-label', titel);
  }

  function bauen() {
    var schalter = document.querySelectorAll('[class*="feature-toggle-"]');
    if (!schalter.length) return false;
    var getan = false;
    [].forEach.call(schalter, function (s) {
      var svgs = s.querySelectorAll('svg');
      if (svgs.length < 2) return;
      /* Links steht die Zunehmen-Seite - dort war die Sonne. */
      zeichen(svgs[0], '+', 'Zunehmen');
      zeichen(svgs[1], '−', 'Abnehmen');   /* echtes Minuszeichen, kein Bindestrich */
      getan = true;
    });
    return getan;
  }

  function versuchen() {
    if (bauen()) return;
    /* Die Sektion wird von der App nachgebaut. */
    var n = 0;
    var t = window.setInterval(function () {
      n++;
      if (bauen() || n > 30) window.clearInterval(t);
    }, 500);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', versuchen);
  } else { versuchen(); }
  window.addEventListener('load', versuchen);
})();
